import { createSelector } from 'reselect';
import keys from 'lodash/keys';
import pick from 'lodash/pick';
import { omitEmpty } from 'lib/object';
import { DEFAULT_FILTERS } from 'lib/enums/search';
import { getQuery } from './querySelectors';

export const getFilterCount = createSelector(getQuery, (query) => {
  const filters = pick(query, keys(DEFAULT_FILTERS));
  return keys(omitEmpty(filters)).length;
});
